// WordPress sends empty ACF repeater rows as "", so a 3-item array can carry no claim at all.
export function resolveHeroClaims(subClaims: string[] | null | undefined, fallback: string[]): string[] {
    const claims = (subClaims ?? []).map((claim) => claim.trim()).filter(Boolean)
    return claims.length ? claims : fallback
}
